import { FilterMatchMode } from 'primereact/api';

export const isSelectable = (data: any) => {
  return !data.data.added;
};

export const filters = {
  device: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
};
